export default __webpack_public_path__ + "static/media/community-hero.98d5357c.png";